<div class="ml-2 flex h-16 flex-row">
  <div
    *ngIf="!!fractionControl.label"
    class="text-s1 mr-5 flex h-9 flex-shrink-0 select-none items-center text-base"
    >{{ fractionControl.label }}</div
  >

  <div
    tp="Turn off formula to activate control"
    [tpIsEnabled]="isDisabled === true"
  >
    <div
      tp="The value can be set using the metrics time filter (at the top of this page)"
      [tpIsEnabled]="fractionControl.isMetricsDate === true"
    >
      <vaadin-date-picker
        #vDatePicker
        class="py-0"
        required
        [value]="
          fractionControl.value.split('$METRICS_DATE_FROM').length > 1
            ? metricsStartDateYYYYMMDD
            : fractionControl.value.split('$METRICS_DATE_TO').length > 1
              ? metricsEndDateYYYYMMDD
              : fractionControl.value
        "
        [i18n]="dateI18n"
        (value-changed)="dateValueChanged($event)"
        [disabled]="
          isDisabled === true ||
          (isMetricsPage === true && fractionControl.isMetricsDate === true)
        "
      ></vaadin-date-picker>
    </div>
  </div>
</div>
